export default __webpack_public_path__ + "static/media/gallery-7.c7a6ce87.jpg";